import { useEffect, useState } from "react";
import { Music2 } from "lucide-react";
import { toast } from "sonner";
import { API, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

const TikTokManager = () => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    API.get("/tiktok/videos")
      .then(({ data }) => setText((data.urls || []).join("\n")))
      .catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const urls = text.split("\n").map((u) => u.trim()).filter(Boolean);
      const { data } = await API.put("/admin/tiktok", { urls });
      toast.success(`${data.count} vídeo(s) guardado(s). Ya se ven en la portada.`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-8 max-w-2xl space-y-6" data-testid="tiktok-manager">
      <div className="rounded-2xl border border-gold/30 bg-gold/5 p-4">
        <p className="text-sm leading-relaxed text-slate-300">
          <span className="font-bold text-gold">Cómo añadir tus vídeos:</span> abre cada vídeo en
          TikTok, pulsa <span className="font-bold text-white">Compartir → Copiar enlace</span> y
          pégalo aquí, uno por línea. Los 3 primeros aparecerán reproducibles en la sección TikTok
          de la portada.
        </p>
      </div>
      <div>
        <p className="mb-2 flex items-center gap-2 font-mono-score text-[11px] uppercase tracking-widest text-slate-400">
          <Music2 className="h-4 w-4 text-crimson" /> Enlaces de vídeos (uno por línea)
        </p>
        <textarea
          rows={8}
          data-testid="tiktok-urls"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="https://www.tiktok.com/@enolfc/video/7123456789012345678"
          className="w-full rounded-xl border border-edge bg-ink2 px-3 py-2 font-mono-score text-sm text-white placeholder:text-slate-500 focus:border-crimson focus:outline-none"
        />
      </div>
      <Button
        onClick={save}
        disabled={busy}
        data-testid="tiktok-save"
        className="rounded-full bg-crimson px-8 py-3 font-display text-base font-bold uppercase tracking-wider hover:bg-glow"
      >
        {busy ? "Guardando..." : "Guardar vídeos"}
      </Button>
    </div>
  );
};

export default TikTokManager;
